import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-left",
  "use": "icon-arrow-down-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-arrow-down-left-icon lucide-arrow-down-left\" id=\"icon-arrow-down-left\"><path d=\"M17 7 7 17\" /><path d=\"M17 17H7V7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol